var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RuntimeModeIndicator"},[_c('b-tooltip',{attrs:{"label":_vm.tooltipLabel,"position":"is-bottom","type":"is-dark"}},[_c('b-tag',{staticClass:"mode-indicator",attrs:{"type":_vm.tagType,"size":"is-small"}},[_c('i',{staticClass:"mr-1",class:_vm.iconClass}),_vm._v("\n      "+_vm._s(_vm.modeText)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }